import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { ROTA } from '../dominio/Rota';
import Store from './Store';
import { LOCALSTORAGE_STORAGE } from '@/util/StorageUtil';

/**
 * Classe utilizada para guardar e manipular o estado da aplicação.
 * Deve-se criar uma para cada contexto ou entidade.
 */
export default class RouterStore extends Store {
    routerStore;
    storeRotaAtual;
    lastRoute;
    redirecionandoRota = false;

    constructor(rootStore, routerStore) {
        super(rootStore);

        makeObservable(this, {
            lastRoute: observable,
            redirecionandoRota: observable,
            objetoLocalStorage: computed,
            push: action,
            isSalaSessao: computed,
            isPautaJulgamento: computed,
            isAcompanhamentoSessao: computed,
            isPreSessao: computed,
            isErro: computed
        });

        if (!routerStore) {
            throw new Error('RouterStore não foi inicializada corretamente.');
        }

        this.routerStore = routerStore;
    }

    get storageType() {
        return LOCALSTORAGE_STORAGE;
    }

    get objetoLocalStorage() {
        return {
            nomeStore: 'RouterStore',
            lastRoute: this.lastRoute
        };
    }

    push(route) {
        this.redirecionandoRota = true;
        this.lastRoute = route;
        this.routerStore.push(route);
        setTimeout(() => runInAction(() => (this.redirecionandoRota = false)), 10);
    }

    get location() {
        return this.routerStore.location;
    }

    get isSalaSessao() {
        return this.location.pathname.indexOf(ROTA.SESSAO.rota) !== -1;
    }

    get isPautaJulgamento() {
        return this.location.pathname.indexOf(ROTA.PAUTA.rota) !== -1;
    }

    get isAcompanhamentoSessao() {
        return this.location.pathname.indexOf(ROTA.ACOMPANHAMENTO_SESSAO.rota) !== -1;
    }

    get isPreSessao() {
        return this.location.pathname.indexOf(ROTA.PRE_SESSAO.rota) !== -1;
    }

    get isErro() {
        return this.location.pathname.indexOf(ROTA.TELA_ERRO.rota) !== -1;
    }
}
